export { default as Loader } from './Loader'
export { Container as LoaderStyled } from './Loader.styles'
